<div *ngIf="languageValues" class="translation">
  <div>
    <si-selector id="translationLanguage"
                 name="translationLanguage"
                 text="SI_LANGUAGE"
                 [(model)]="model"
                 (modelChange)="onChangeLanguage()"
                 [values]="languageValues"
                 valueAttr="id"
                 styleClass="translation_selector"
                 [hideLabel]="true"
                 [showDropdownSearch]="false"
                 [showClear]="false">
      <ng-template #selectedItem let-item>
        <div class="d-flex align-items-center">
          <i class="icosun-language translation_selector_i18n-icon"></i>
          <div *ngIf="!isMobileWidth" class="ml-2">
            <span>{{item.label}}</span>
          </div>
        </div>
      </ng-template>
    </si-selector>
  </div>
</div>
